import { makeAutoObservable, runInAction } from 'mobx'

import type { ParentStudentRes } from '~/@common/api/parentApi'
import { parentApi } from '~/@common/api/parentApi'

// 학부모 프로필 — 자녀 상세 정보 조회 서비스
export class ParentProfileService {
  private _children: ParentStudentRes[] = []

  constructor() {
    makeAutoObservable(this)
  }

  get children() {
    return this._children
  }

  async fetchChildren(studentIds: string[]) {
    if (studentIds.length === 0) return

    try {
      const data = await parentApi.getStudents(studentIds)
      runInAction(() => {
        this._children = data
      })
    } catch {
      // 조회 실패 시 기존 목록 유지
    }
  }
}
